import { Product } from '../';

export const HasId = (id: string) => (product: Product): product is Product => {
  return product.id === id;
};
